export default "__VITE_ASSET__CEf61pv1__"